<template>
    
      <v-sheet class="pa-6" height="600px" style="padding-top:100px;border-radius:50px 50px 0px 0px">
      <v-window v-model="step">
        <v-window-item :value="1">
      <div style="margin:10px auto;max-width:700px">
      <h1>Deposit</h1>
      <p>Enter the amount you will like to deposit</p>
      <v-alert type="error" dense v-model="alert">{{message}}</v-alert>
      <v-form @submit.prevent="checkDeposit()">
        <v-text-field @keyup="setAmount()" :prefix="userData.currency" style="height:69px" type="number" label="Amount" class="rounded-lg" v-model="amount" outlined :color="userData.btncolor"/>
       </v-form>
        <v-btn @click="checkDeposit()" x-large :color="userData.btncolor" block class="white--text rounded-lg"> Proceed</v-btn>
         </div>
        </v-window-item>

        <v-window-item :value="2">
          <v-btn text @click="step--" class="mb-2"><v-icon>mdi-arrow-left</v-icon>Back</v-btn>
          <div style="max-width:700px;margin:10px auto">
           <paystack
            :amount="amount * 100"
            :email="userData.email"
            :paystackkey="paystackkey"
            :reference="reference"
            :callback="callback"
            :close="close"
            :embed="false"
            style="width:100%;margin:auto"
             class="animate__animated animate__fadeInUp animate__fast"
            v-if="userData.currency == 'NGN'"
          >
          <v-btn block outlined x-large class="rounded-lg d-flex justify-space-between">
            <v-icon>mdi-bank</v-icon>
            <span class="ml-5">Pay with Bank </span></v-btn>
            </paystack>



          <flutterwave
            :userData="userData"
            :is-production="isProduction"
            :name="userData.name"
            :email="userData.email"
            :amount="amount"
            :reference="referenceFlutter"
            flw-key="FLWPUBK-dbe851d7b426b96d183b36373de5959f-X"
            :callback="callbackFlutter"
            :close="close"
            :currency="userData.currency"
            :country="country"
            :payment_method="paymentMethod"
            class='mt-3 animate__animated animate__fadeInUp'
          />

          <v-btn @click="paywithpayChant()" block outlined x-large 
          class="rounded-lg d-flex justify-space-between mt-4 animate__animated animate__fadeInUp animate__slow"
          
          >
            <v-icon>mdi-bitcoin</v-icon>
            <span class="ml-5">Pay with Crypto </span></v-btn>


            <div>
    <form action="https://pay.paychant.com/button/payment" method="post">
    <input type="hidden" name="params" :value="`currency=${userData.currency}&amount=${amount}&success_url=https:/tippings.me/wallet/${userData.uid}/${userSlug}/success`"/>
    <input type="hidden" name="data" value="k7YLPsnywEaud9pGJbH/JAREA0PElo/CkVYhxf/F7n7ykDtfr28gHjycLqXDb6ctWZKReu3iGW58nrW3O6pPv2xnNFJrTUlMODM"/>
    <input type="image"  target="_blank" hidden ref="paychant" src="https://paychant.com/btn/p_pay.svg" name="submit" style="width: 200px;" alt="Paychant, pay with bitcoin easily."/>
</form>
</div>

            <v-btn target="_blank" :href="`https://api.whatsapp.com/send?phone=2348167299743&text=Hi%20Tippings!.%20My%20name%20is%20${this.userData.name}%20and%20I%20would%20like%20to%20credit%20my%20Tippings%20wallet%20with%20${this.userData.currency}%20${this.amount}`" block outlined x-large 
          class="rounded-lg d-flex justify-space-between mt-4 animate__animated animate__fadeInUp animate__slower"
          
          >
            <v-icon>mdi-whatsapp</v-icon>
            <span class="ml-5">Pay with WhatsApp </span></v-btn>




            </div>
        </v-window-item>
      </v-window>
      </v-sheet>
   
</template>



<script>
import Flutterwave from './FlutterwaveDeposit.vue'
import Paystack from "vue-paystack"
import slugify from 'slugify'
import moment from 'moment'
import {doc,setDoc,arrayUnion,increment} from 'firebase/firestore'
import db from "../db"
//import axios from 'axios'




export default {
    components:{
        Flutterwave,
        Paystack
    },
    data(){
        return{
      paystackkey: "pk_live_d9516c4c9ed7efe222ec1a27c8eb5ad049d2eeab", //paystack public key
      paystackRef: "",
      flutterwaveRef:"",
      isProduction: true,
      flwKey: "FLWPUBK-dbe851d7b426b96d183b36373de5959f-X",
      overlay:false,
       country: "",
      paymentMethod: "",
      deposit:false,
      step:1,
      alert:false,
      message:"",
      amount:""
        }
    },
    props:{
        currency:{
            type:String,
        },
        giftPersonData:{
            type:Object,
        },
        userData:{
            type:Object
        },
        user:{
            type:Object
        },
        userSlug:{
            type:String
        }
    },
    computed:{
    
    authorSlug(){
       return slugify(this.userData.displayName, {
        replacement: "-",
        remove: /[$*_+~.()'"!:@]/g,
        lower: true,
      });
    },
  
    reference() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    },

     referenceFlutter() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    },
     
  },

  watch:{
    paystackRef() {
      this.changesInDatabase();
    },
     flutterwaveRef() {
      this.changesInDatabase();
    },
  },

 

   methods:{
    closeDeposit(){
     this.$emit('closeDeposit')
    },

    setAmount(){
      localStorage.setItem(this.userData.uid,this.amount)
      localStorage.setItem("currency",this.userData.currency)
    },

    goBack() {
      this.$router.go(-1);
    },


   

    //function to fire when payment is successful
    changesInDatabase(){
    this.$emit("resolving")
      const payLoad = {
        "title":"Account Credited",
        "amount":parseFloat(this.amount),
        "transaction_id":'transaction_'+Math.random()*10000000000,
        "timestamp":moment(Date.now()).format("LLL"),
        "status":"Success",
        "image":"https://i.ibb.co/8mRPfhc/credit-card-2.png",
        "currency":this.userData.currency
      }

      const notificationPayload ={
          "message":`"${this.userData.currency} ${this.amount} has been credited to your wallet"`,
          "timestamp":moment(Date.now()).format("LLL"),
           "title":"Account Credited"

      }
      const userRef = doc(db,"users",localStorage.getItem("tippingsKey"))
      setDoc(userRef,{
        transactions:arrayUnion(payLoad),
        notifications:arrayUnion(notificationPayload),
        wallet:increment(parseFloat(this.amount))
        
      }, 
      {merge:true}
      )
      .then(()=>{
        this.$swal({
          title: "Success",
          text: "You have successfully credited your account",
          icon: "success",
          button: "OK",
        }).then(()=>{
          this.$store.dispatch("fetchUserData")
        })
      })
    },

    paywithpayChant(){
      this.$refs.paychant.click()
    },


    // changeCurrency(){
    //   this.convertLoading = true
    //   axios({
    //     method:"POST",
    //     url:"https://tellbooksapi.herokuapp.com/converter",
    //     data:{
    //       "currency":this.currency,
    //       "newCurrency":this.newCurrency
    //     }
    //   }).then((response)=>{
    //     console.log(response.data)
    //     const userRef = doc(db,"users",this.authorSlug)
    //      updateDoc(userRef,{
    //        "rate":response.data,
    //        "currency":this.newCurrency,
    //        "balance":this.walletBalance*response.data
    //      }).then(()=>{
    //        this.convertLoading = false
    //        this.$store.dispatch("fetchUserData",this.authorSlug)
    //      })
    //   }).catch((error)=>{
    //      this.convertLoading = false
    //     this.$swal({
    //       title: "Something went wrong",
    //       text: error.message,
    //       icon: "error",
    //       button: "Ok",
    //     })
    //   })
    // },

    

     makePayment() {
      window.FlutterwaveCheckout({
        public_key: this.flwKey,
        tx_ref: this.referenceFlutter,
        amount: this.amount,
        currency: this.userData.currency,
        payment_options: this.payment_method,
        customer: {
          name: this.userData.displayName,
          email: this.userData.email
        },
        callback: response => this.callback(response),
        customizations: {
          title: this.custom_title,
          description: "Payment for items in cart",
          logo: this.custom_logo
        }
      });
    },

      close: () => {
      console.log("You closed checkout page");
      this.error = "You closed checkout page";
      this.snackbar = true;
    },

     callback(response) {
      this.paystackRef = response.reference;
    },

    callbackFlutter(response) {
      this.flutterwaveRef = response.referenceFlutter;
    },

    checkDeposit(){
    if(this.amount == ''){
        this.$swal({
            title:"Please enter an amount",
            icon:"error"
        })
    }
      if(this.amount != 0){
        this.step++
      }
    },


    checkAmount(){
       if(this.amount > (this.walletBalance)){
      this.disabled = true
    } else{
      this.disabled = false
      localStorage.setItem(this.userData.uid,this.amount)
    }
    },

   }
}
</script>